import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import LandingTestimonial from "@/components/LandingTestimonial";

const IDX_KEY = "umbra_hero_quote_idx";

function nextIndex(n) {
  try {
    const prev = Number(window.localStorage.getItem(IDX_KEY));
    const idx = Number.isFinite(prev) && window.localStorage.getItem(IDX_KEY) !== null ? (prev + 1) % n : Math.floor(Math.random() * n);
    window.localStorage.setItem(IDX_KEY, String(idx));
    return idx;
  } catch {
    return Math.floor(Math.random() * n);
  }
}

// With 3+ Live listener stories, show a different one each visit; otherwise the existing comment rotator.
export default function HeroTestimonial() {
  const [state, setState] = useState({ ready: false, story: null });
  const idxRef = useRef(null);

  useEffect(() => {
    api.get("/listener-stories")
      .then((r) => {
        const s = r.data.stories || [];
        if (s.length >= 3 && idxRef.current === null) idxRef.current = nextIndex(s.length);
        setState({ ready: true, story: s.length >= 3 ? s[idxRef.current % s.length] : null });
      })
      .catch(() => setState({ ready: true, story: null }));
  }, []);

  if (!state.ready) return null;
  if (!state.story) return <LandingTestimonial />;
  const s = state.story;

  return (
    <figure className="mt-10 sm:mt-14 max-w-2xl border-l-2 border-terracotta pl-5 sm:pl-6 py-2 animate-fade-up" data-testid="hero-listener-quote">
      <p className="font-sans uppercase tracking-[0.24em] text-[0.6rem] text-terracotta mb-3">Listener story</p>
      <blockquote className="font-serif italic text-bone-200 text-lg leading-relaxed" data-testid="hero-listener-quote-text">
        &ldquo;{s.quote}&rdquo;
      </blockquote>
      <figcaption className="mt-3 font-sans text-[0.65rem] uppercase tracking-[0.24em] text-bone-500" data-testid="hero-listener-quote-name">
        — {s.first_name}
        {s.outcome ? ` · ${s.outcome}` : ""}
      </figcaption>
    </figure>
  );
}
